import React from 'react';
import PropTypes from 'prop-types';

import LocationSearchBox from '../../components/LocationSearchBox';


const Location = ({ value, onChange }) => {
  return (
    <LocationSearchBox
      title={'Enter the service location'}
      onSearchChange={onChange}
      selectedValue={value}
    />
  );
};

Location.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default Location;